import React from "react";
import { Chip, Box } from "@mui/material";
import { unitSizeMetadata } from "model/interest/unit-size";
import { extendedStates } from "components/haven-design/state-picker";
import { formatAsCurrency } from "pages/dashboard/utils";
import { Filters } from "./filters-modal";

const removeState = (filters:Filters, value:string) => ({
  ...filters,
  selectedStates: filters.selectedStates.filter(state => state !== value),
});

const removeCity = (filters:Filters, value:string) => ({
  ...filters,
  selectedCities: filters.selectedCities.filter(city => city !== value),
});

const removeUnitSize = (filters:Filters, value:string) => ({
  ...filters,
  unitSizes: filters.unitSizes.filter(unitSize => unitSize !== value),
});

const margin = 0.5;
const styles = {
  margin,
  "& .MuiChip-deleteIcon": {
    color: "white",
  },
};

const FilterChips:React.FC<{
  filters:Filters,
  onChange:(values:Filters) => void,
}> = ({ filters, onChange }) => (
  <Box sx={{
    marginLeft: -margin,
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme => theme.spacing(0.5),
    },
    color: "white",
  }}>
    {filters.selectedStates.map(state =>
      <Chip
        key={state}
        color="primary"
        // @ts-ignore
        label={extendedStates[state]}
        onDelete={() => onChange(removeState(filters, state))}
        sx={styles}
      />)}
    {filters.selectedCities.map(city =>
      <Chip
        key={city}
        color="primary"
        label={city}
        onDelete={() => onChange(removeCity(filters, city))}
        sx={styles}
      />)}
    {filters.unitSizes.map(unitSize =>
      <Chip
        key={unitSize}
        color="primary"
        label={unitSizeMetadata.find(data => data.id.toLowerCase() === unitSize.toLowerCase())?.label ?? ""}
        onDelete={() => onChange(removeUnitSize(filters, unitSize))}
        sx={styles}
      />)}
    {filters.income !== null && <Chip
      color="primary"
      label={`${formatAsCurrency(filters.income.toString())} per ${filters.incomeFrequency}`}
      onDelete={() => onChange({ ...filters, income: null })}
      sx={styles}
    />}
  </Box>
);

export { FilterChips };
